const cacheBuster = Date.now();

interface RemoteWindow {
  __remoteUrls?: Record<string, string>;
  __remoteUrlResolver?: (remoteName: string) => string;
}

fetch('/assets/module-federation.manifest.json')
  .then(res => res.json())
  .then((definitions: Record<string, string>) => {
    const w = window as unknown as RemoteWindow;
    w.__remoteUrls = definitions;
    w.__remoteUrlResolver = (remoteName: string) => `${ definitions[ remoteName ] }/remoteEntry.mjs?v=${ cacheBuster }`;
  })
  .then(() => import('./bootstrap').catch(err => console.error(err))); // NOSONAR
